import { CHECKOUT_MEGAPACK, CHECKOUT_MEGAPACK_KIT } from '../data/content'

export const META_PIXEL_ID = '761617479540023'

type FbqFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue?: unknown[]
  push?: unknown
  loaded?: boolean
  version?: string
}

declare global {
  interface Window {
    fbq?: FbqFunction
    _fbq?: FbqFunction
  }
}

/**
 * Injects the official Meta Pixel base code and fires the initial PageView.
 * Safe to call more than once — it bails out if the pixel is already present.
 */
export function initMetaPixel(pixelId: string = META_PIXEL_ID): void {
  if (typeof window === 'undefined') return

  if (!window.fbq) {
    const fbq: FbqFunction = function (...args: unknown[]) {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, args)
      } else {
        fbq.queue?.push(args)
      }
    } as FbqFunction

    fbq.queue = []
    fbq.push = fbq
    fbq.loaded = true
    fbq.version = '2.0'

    window.fbq = fbq
    window._fbq = fbq

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)

    const noscript = document.createElement('noscript')
    const pixelImage = document.createElement('img')
    pixelImage.height = 1
    pixelImage.width = 1
    pixelImage.alt = ''
    pixelImage.style.display = 'none'
    pixelImage.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`
    noscript.appendChild(pixelImage)
    document.body.appendChild(noscript)
  }

  window.fbq?.('init', pixelId)
  window.fbq?.('track', 'PageView')
}

export function trackPixelEvent(
  eventName: string,
  params?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', eventName, params)
}

type CheckoutProduct = {
  contentName: string
  value: number
}

const checkoutProducts: Record<string, CheckoutProduct> = {
  [CHECKOUT_MEGAPACK]: {
    contentName: 'MegaPack Caligrafía y Lectoescritura',
    value: 19990,
  },
  [CHECKOUT_MEGAPACK_KIT]: {
    contentName: 'MegaPack + Kit Inclusión',
    value: 27990,
  },
}

/** Fires InitiateCheckout with the matching product value for a checkout link. */
export function trackCheckoutClick(href: string): void {
  const product = checkoutProducts[href]
  if (!product) return

  trackPixelEvent('InitiateCheckout', {
    content_name: product.contentName,
    content_type: 'product',
    currency: 'ARS',
    value: product.value,
  })
}
